export const SEND_MESSAGE = 'dashboard/messages/SEND_MESSAGE';
export const ACTION_MESSAGE = 'dashboard/messages/ACTION_MESSAGE';
